import store from '../store'

export default function guest (to, from, next) {
  if (store.getters['auth/isAuthenticated']) {
    return next({
      name: 'site',
      params: { url: to.params.url }
    })
  }
}
